import { EventManager } from '../event-manager.class'
import { BrowserTab } from './BrowserTab.class'
import ITC_OP_TYPES from './Op.enum';

if (typeof window !== 'undefined' && !window._ifTabInfo) {
  window._ifTabInfo = new BrowserTab()
  window._ifOtherTabInfo = []
  window._ifITCEvents = new EventManager()

  const myTab = window._ifTabInfo
  const otherTabs = window._ifOtherTabInfo
  const itcEvents = window._ifITCEvents
  

  if (typeof window !== 'undefined') {
    window.document.addEventListener("visibilitychange", (screenEvent) => {
      screenEvent.target.hidden
      myTab.events.dispatch('hidden', { hidden: screenEvent.target.hidden })
    });
    window.addEventListener("focus", () => {
      myTab.events.dispatch('active')
    });
  }

  myTab.events.addEventListener('message', (eventObject) => {
    let changed = false
    if ([ITC_OP_TYPES.SYNC, ITC_OP_TYPES.FORCE_SYNC].includes(eventObject.type)) {
      const currentTimestamp = new Date().getTime()
      const targetTab = otherTabs.find(tab => tab.id === eventObject.fromID)
      if (eventObject.fromID !== myTab.id) {
        if (targetTab) {
          targetTab._info = eventObject.data && eventObject.data.info
          targetTab.touch()
          changed = !!eventObject.data.changed
        } else {
          changed = true
          otherTabs.push(new BrowserTab(eventObject.data))
        }
      }

      const gcTargetTabs = otherTabs
                                .map(tab => currentTimestamp - tab.latestSyncTime > 2200 ? tab : null)
                                .filter(tab => tab)
      gcTargetTabs.forEach(tab => {
        const targetID = tab.id
        const index = otherTabs.findIndex(oTab => oTab.id === targetID)
        if (index >= 0) {
          changed = true
          otherTabs.splice(index, 1)
        }
      })
      
      if (changed) {
        itcEvents.dispatch('update', { myTab: myTab, otherTabs: otherTabs, eventObject: eventObject, removed: gcTargetTabs })
      }
      
      if (eventObject.type === ITC_OP_TYPES.FORCE_SYNC) {
        myTab.sync()
      }
    } else if (eventObject.type === ITC_OP_TYPES.EVAL) {
      const cmdString = eventObject.data || ''

      if (eventObject.targetID && eventObject.targetID !== myTab.id) {
        // targetID가 설정되면 targetID와 자신의 탭 ID가 같을때에만 실행
        return
      }

      try {
        eval(`${cmdString}`)
      } catch (e) {
        //console.log('EVAL COMMAND ERROR ', e)
      }
    } else {
      // unknown event type
    }
  })

  if (!process.env.JEST_WORKER_ID) {
    myTab.forceSync()
    setInterval(() => gcForTab(), 2000)
  }
}



function gcForTab() {
  ITC.forceSync()
}

export class ITC {

  constructor() {
    console.error('cannot use the constructor in ITC Class.')
  }

  static get events() {
    const itcEvents = window._ifITCEvents
    return itcEvents
  }

  static getMyTab() {
    const myTab = window._ifTabInfo
    return myTab
  }

  static getOtherTabs() {
    const otherTabs = window._ifOtherTabInfo
    return otherTabs
  }

  static allTabs() {
    const myTab = ITC.getMyTab()
    const otherTabs = window._ifOtherTabInfo
    return [myTab, ...otherTabs]
  }

  static forceSync() {
    ITC.getMyTab().forceSync()
  }

  static dispatchEvalCommand(command, targetID) {
    if (!command || typeof command !== 'string') {
      return
    }
    ITC.getMyTab().sendToEval(command, targetID)
  }

  static getOldestTab() {
    return ITC.allTabs().reduce((result, tab) => {
      if (result && result.createdAt < tab.createdAt) {
        return result;
      }
    
      result = tab
      return result
    } ,null) || ITC.getMyTab()
  }

  static getLatestTab() {
    return ITC.allTabs().reduce((result, tab) => {
      if (result && result.createdAt > tab.createdAt) {
        return result;
      }
      result = tab
      return result
    } ,null) || ITC.getMyTab()
  }

}
